export const theme = {
  colors: {
    bg: '#212121',
    primary: '#ff0000',
    text: '#ffffff',
    react: '#61dafb',
  },
};
